<template>
  <aside v-if="linkDetails" class="automated-link">
    <a-link
      :to="prop('linkURL', linkDetails)"
      :directive="prop('robotDirectives', linkDetails)"
      :open-in-new-tab="prop('openInNewTab', linkDetails)"
    >
      {{ prop('title', linkDetails) }}
    </a-link>
  </aside>
</template>

<script>
import { prop } from 'ramda'
import { PROP_TYPES, propValidator } from '@/utils/validators'

export default {
  name: 'AAutomatedLink',
  props: {
    linkDetails: propValidator([PROP_TYPES.OBJECT])
  },
  methods: {
    prop
  }
}
</script>

<style lang="scss" scoped>
.automated-link {
  margin-bottom: 30px;
}

.automated-link a {
  font-weight: 700;
  font-size: 19px; /* https://app.zeplin.io/project/5ca46561ed21e79faa0ed732/screen/5cab3793fdfc71a25a4e2926 */
  line-height: 27px;
}
</style>
